import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router';

import {
    styled,
    AppBar as MaterialAppBar,
    Toolbar,
    IconButton,
    alpha
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

import { createShadow } from '@libs/materialUI';
import { renderedComponentPropType } from '@libs/propTypes';
import { useAppBarStyle } from './hooks';
import { usePath } from '../hooks';
import useNavigation from '../useNavigation';
import EndAdornment from './EndAdornment';

const propTypes = {
    adornments: PropTypes.arrayOf(renderedComponentPropType)
};

const defaultProps = {
    adornments: []
};

const StyledAppBar = styled(MaterialAppBar)(
    ({ theme: { palette, transitions } }) => ({
        width: '100%',
        height: `calc(var(--appBarHeight))`,
        paddingLeft: 'var(--appBarPadding)',
        backgroundColor: palette.background.white,
        paddingRight: '0px !important',
        boxShadow: createShadow({
            vOffset: 2,
            blur: 4,
            spread: -2,
            color: alpha(palette.mode === 'dark' ? palette.common.white : palette.common.black, 0.18)
        }),
        transition: transitions.create('padding', {
            easing: transitions.easing.sharp,
            duration: transitions.duration.shorter
        })
    })
);
const StyledToolbarBar = styled(Toolbar)(({ theme: { palette, spacing } }) => ({
    width: '100%',
    height: 'var(--appBarHeight)',
    backgroundColor: palette.background.white,
    paddingLeft: spacing(2),
    paddingRight: 0,
    boxShadow: createShadow({
        hOffset: spacing(10),
        blur: spacing(10),
        spread: spacing(-10),
        color: alpha(palette.mode === 'dark' ? palette.common.white : palette.common.black),
        inset: true
    }),
    display: 'flex',
    justifyContent: 'space-between'
}));

const AppBar = ({ adornments }) => {
    const location = useLocation();
    usePath(location);

    const [{ isDrawerVisible }, dispatch] = useNavigation();

    const handleMenu = useCallback(
        () =>
            dispatch({
                type: 'setDrawerVisibility',
                payload: !isDrawerVisible
            }),
        [dispatch, isDrawerVisible]
    );

    return (
        <StyledAppBar position='fixed' style={useAppBarStyle()}>
            <StyledToolbarBar>
                <IconButton onClick={handleMenu}>
                    <MenuIcon />
                </IconButton>
                <EndAdornment adornments={adornments} />
            </StyledToolbarBar>
        </StyledAppBar>
    );
};

AppBar.propTypes = propTypes;
AppBar.defaultProps = defaultProps;

export default AppBar;
